// extracted by mini-css-extract-plugin
export var formContainer = "_il-0";
export var message = "_il-1";